import { combineReducers } from 'redux'
import list from './list'
import createTemporary from './createTemporary'

export default combineReducers({
  list,
  createTemporary,
})
